<template>
    <div class="icon-table">

        <div class="select-box clearfix">
            <p class="fr">
                <span :style="{ marginRight: '20px' }">
                    <span>收/支：</span>
                    <a-select :default-value="type" :key="type" style="width: 160px" @change="incomeTypesChange">
                        <a-select-option v-for="type in incomeTypes" :key="type.id" :value="type.id">
                            {{ type.text }}
                        </a-select-option>
                    </a-select>
                </span>
                <span>
                    <span>类型：</span>
                    <a-select
                        :default-value="tradeType"
                        :key="tradeType"
                        style="width: 160px"
                        @change="tradeTypesChange"
                    >
                        <a-select-option v-for="type in tradeTypes" :key="type.id" :value="type.id">
                            {{ type.text }}
                        </a-select-option>
                    </a-select>
                </span>
            </p>
        </div>
        <!-- date -->
        <a-config-provider :locale="locale">
            <a-table bordered :columns="columns" :data-source="list" :pagination="false" rowKey="id">
                <template slot="createTime" slot-scope="text">
                    <span>{{ text | dateTime }}</span>
                </template>
                <template slot="incomeType" slot-scope="text">
                    <span>{{ text | typeToText('incomeType') }}</span>
                </template>
                <template slot="tradeType" slot-scope="text">
                    <span>{{ text | typeToText('tradeType') }}</span>
                </template>
                <template slot="tradeAmount" slot-scope="text">
                    <span>
                        <i>{{ text > 0 ? '+' : '' }}</i>
                        {{ text | numDevide100 }}
                    </span>
                </template>
                <template slot="availableBalance" slot-scope="text">
                    <span>{{ text | numDevide100 }}</span>
                </template>
                <template slot="operation" slot-scope="text, recoder">
                    <a href="javascript:;" @click="detailClick(recoder)">明细</a>
                </template>
            </a-table>
        </a-config-provider>
        <a-config-provider :locale="locale">
            <common-pagination
                class="the-pagenation"
                show-size-selector
                :hideOnSinglePage="false"
                :total="total"
                :default-page="page"
                :default-page-size="10"
                @page-change="pageChange"
                @size-change="showSizeChange"/>
        </a-config-provider>

    </div>
</template>
<script>
    import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
    import { coinDetailList } from '@/store/api/share/team';
    import commonPagination from '@/modules/knowledge-operation/components/common-pagination.vue';

    export default {
        components: {
            commonPagination,
        },
        props: {
            params: {
                type: Object,
                default: () => ({}),
            },
            tradeTypes: {
                type: Array,
                /* 1学币分配 2学币充值 3专栏订阅 4打赏 { id: 2, text: '学币充值' } */
                default: () => ([
                    { id: 0, text: '全部' },
                    { id: 1, text: '分配' },
                    { id: 3, text: '订阅' },
                    { id: 4, text: '打赏' },
                ]),
            }
        },
        data: () => ({
            locale: zhCN,
            page: 1,
            pageSize: 10,
            total: 0,
            accountCode: sessionStorage.getItem('teamID'),
            accountType: 3,
            tradeType: 0,
            type: 0,
            list: [],
            incomeTypes: [
                { id: 0, text: '全部' },
                { id: 1, text: '收入' },
                { id: 2, text: '支出' },
            ],
            columns: [
                {
                    title: '时间',
                    dataIndex: 'createTime',
                    key: '1',
                    scopedSlots: { customRender: 'createTime' },
                    width: 180,
                },
                {
                    title: '收 / 支',
                    dataIndex: 'type',
                    key: '8',
                    scopedSlots: { customRender: 'incomeType' },
                },
                {
                    title: '类型',
                    dataIndex: 'tradeType',
                    key: '2',
                    width: 100,
                    scopedSlots: { customRender: 'tradeType' },
                },
                {
                    title: '数量',
                    dataIndex: 'tradeAmount',
                    key: '3',
                    ellipsis: true,
                    scopedSlots: { customRender: 'tradeAmount' },
                },
                {
                    title: '操作账号',
                    dataIndex: 'createMemberName',
                    key: '4',
                    ellipsis: true,
                },
                {
                    title: '操作姓名',
                    dataIndex: 'createMemberFullName',
                    key: '5',
                    ellipsis: true,
                },
                {
                    title: '余额',
                    dataIndex: 'availableBalance',
                    key: '6',
                    ellipsis: true,
                    scopedSlots: { customRender: 'availableBalance' },
                },
                {
                    title: '操作',
                    dataIndex: 'operate',
                    key: '7',
                    ellipsis: true,
                    scopedSlots: { customRender: 'operation' },
                },
            ],
        }),
        created() {
            this.getCoinDetailList();
        },
        methods: {
            // 收支类型切换
            incomeTypesChange(type) {
                this.page = 1;
                this.type = type;
                this.list = [];
                this.getCoinDetailList();
            },
            // 交易类型切换
            tradeTypesChange(type) {
                this.page = 1;
                this.tradeType = type;
                this.list = [];
                this.getCoinDetailList();
            },
            pageChange(page) {
                this.page = page;
                this.list = [];
                this.getCoinDetailList();
            },
            showSizeChange(page, pageSize) {
                this.page = 1;
                this.pageSize = pageSize;
                this.list = [];
                this.getCoinDetailList();
            },

            // 重置查询参数
            resetOptions() {
                this.page = 1;
                this.pageSize = 10;
                this.tradeType = 0;
                this.type = 0;
            },
            detailClick(data) {
                this.$emit('showModal', 1);
                this.$emit('detailClick', data);
            },
            // 列表
            async getCoinDetailList() {
                this.$root.$children[0].status = 1;
                // accountType 1 机构账号 2 个人账号 3 纷享号账号
                const options = {
                    accountCode: this.accountCode,
                    accountType: this.accountType,
                    page: this.page,
                    pageSize: this.pageSize,
                    tradeType: this.tradeType === 0 ? '' : this.tradeType,
                    type: this.type === 0 ? '' : this.type,
                    ...this.params,
                };
                const {
                    data: { items, recordCount },
                } = await coinDetailList(options);
                this.list = items;
                this.total = recordCount;
                this.$root.$children[0].status = 0;
            },
        },
    };
</script>
<style lang="less">
.icon-table {
    .ant-table-wrapper .ant-table .ant-table-thead > tr:first-child > th:first-child {
        text-align: center;
    }

    .select-box {
        margin-bottom: 20px;
    }
    .ant-select-selection {
        border-radius: 2px;
    }
    .the-pagenation {
        margin: 40px 0;
    }
}
</style>
